const EventCardData = [



    // {

    //     id: 1,
    //     imgsrc: "https://yugalkunj.org/images/holika_dahan_2026.jpeg",
    //     Link: "https://yugalkunj.org/images/holika_dahan_2026.jpeg",
    //     title: "Mahaprabhu Jayanti & Holika Dahan",
    //     Desc: "Join us for the auspicious celebration of Mahaprabhu Jayanti and Holika Dahan. Experience the divine atmosphere with special prayers, rituals, and the sacred bonfire ceremony marking the victory of good over evil."



    // },


    // {

    //     id: 2,
    //     imgsrc: "https://yugalkunj.org/images/holi_celebartion-2026.jpeg",
    //     Link: "https://yugalkunj.org/images/holi_celebartion-2026.jpeg",
    //     title: "Holi Celebrations at Yugal Kunj",
    //     Desc: "Celebrate the festival of colors with joy and devotion! Join us for Braj Style Flower Holi with traditional music, dance, and spiritual festivities. Experience the divine play of colors in a devotional atmosphere."



    // },


    // {

    //     id: 3,
    //     imgsrc: "https://yugalkunj.org/images/Talentandfashion%20.jpeg",
    //     Link: "https://schools.procareconnect.com/form/2bc451d3-e340-4166-bc33-3d19ff834df9",
    //     title: "Talent and Fashion Show",
    //     Desc: "Join us for an exciting evening showcasing talent and fashion! Register now to participate or attend this spectacular event featuring performances, fashion displays, and cultural presentations."



    // },


    {

        id: 4,
        imgsrc: "https://stssevastorage.blob.core.windows.net/ykwebsite/event/recent-event1.jpg",
        Link: "#",
        title: "Life Story Of Shri Maharaji In His Own Words",
        Desc: "The first spiritual conference I organized was in Chitrakoot. No conference of the kind had ever been organized before, and it lasted 16 days. Many arguments took place during it. Eventually I had to speak on the stage. There was a speaker by the name Pathik Ji Maharaj; he challenged me. I had ........ "



    },


    {

        id: 5,
        imgsrc: "https://stssevastorage.blob.core.windows.net/ykwebsite/event/recent-event2.jpg",
        Link: "#",
        title: "Winter Retreat Blog",
        Desc: "Yugal Kunj celebrated its yearly winter family retreat with much anticipation and enthusiasm. Devotees from all over enjoyed the daily activities led by Sushri Siddheshvari Didiji. The week had three different schedules for teens, kids and adults focusing on different aspects for each age group...    "



    },

    {

        id: 6,
        imgsrc: "https://stssevastorage.blob.core.windows.net/ykwebsite/event/recent-event3.jpg",
        Link: "#",
        title: "Karuna Sagar",
        Desc: "God is 'Karuna Sagar.' He is the unlimited ocean of mercy and compassion. Saint Tulsidas writes in Vinay Patrika that Bhagvan Shri Ram is compassionate to one and all. Gaurang Mahaprabhu says – O Krishna! There are only three ways in which You will behave towards me. You will give me a loving em........   "



    },




];


export default EventCardData;